import ArrowRight from "./ArrowRight";

const Icon = {
  ArrowRight,
};

export default Icon;
